import { Date } from '@mobiscroll/react';
import './index.css';

export default Date;
